app.component("incisions", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/incisions/incisions.html",
	controller: "incisionsController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("incisionsController", [
	"$scope",
	"INCISIONSIZE",
	function ($scope, INCISIONSIZE) {
		$scope.incisionSize = INCISIONSIZE.map((t) => t);

        $scope.removeIncision = function (index) {
			$scope.$ctrl.data.incision.incisions.splice(index, 1);
		};

		$scope.addIncision = function () {
			if (
				!$scope.$ctrl.form.incision_size.val ||
				!$scope.$ctrl.form.incision_enlargement ||
				(!$scope.$ctrl.form.incision_location_degree && $scope.$ctrl.form.incision_location_degree !== 0) ||
				!$scope.$ctrl.form.incision_location
			) {
				return;
			}
			let size, enlargement, location_degree, location;
			try {
				size = $scope.$ctrl.form.incision_size.val;
				enlargement = $scope.$ctrl.form.incision_enlargement;
				location_degree = $scope.$ctrl.form.incision_location_degree;
				location = $scope.$ctrl.form.incision_location;
			} catch (error) {
				return;
			}

			if (!$scope.$ctrl.data.incision.incisions) {
				$scope.$ctrl.data.incision.incisions = [];
			}
			$scope.$ctrl.data.incision.incisions.push({
				size: size ? Number.parseFloat(size.id).toFixed(1) : null,
				enlargement,
				location_degree,
				location_type: location,
			});
			// reset fields to empty
			this.$ctrl.form.incision_size.val = null;
			this.$ctrl.form.incision_location_degree = null;
			$scope.warn = false;
		};

		$scope.onChange = function () {
			if (angular.isString($scope.$ctrl.form.incision_size.val)) {
				$scope.$ctrl.form.incision_size.val = {
					id: $scope.$ctrl.form.incision_size.val,
					name: $scope.$ctrl.form.incision_size.val,
				};
				if (!$scope.incisionSize.find((t) => t.name === $scope.$ctrl.form.incision_size.val.name)) {
					$scope.incisionSize.push($scope.$ctrl.form.incision_size.val);
				}
			}
			$scope.showWarn();
		};

		$scope.showWarn = function () {
			$scope.warn = true;
		};
	},
]);
